import React from "react";
import DatePicker from "react-datepicker";

export default function DateInputWrapper({
  startDate,
  disabled,
  placeholder,
  onChange,
  label,
  error,
  value,
  errorText,
  icon,
  readOnly,
  minDate,
  className
}) {
  const selectedDate = value ? new Date(value) : startDate;

  return (
    <div className="input__outer">
      {label && <label className="!mb-1">{label}</label>}
      <div
        className={
          `input ${className} ` +
          (error && value === "" ? "error " : "") +
          (icon ? "wIcon" : "")
        }
      >
        <DatePicker
          disabled={disabled}
          onChange={onChange}
          startDate={disabled ? "" : selectedDate}
          placeholderText={placeholder}
          selected={selectedDate}
          readOnly={readOnly}
          minDate={minDate}
          className=""
        />
        {icon && <div className={`input__icon simple mt-3 mr-3`}>{icon}</div>}
      </div>
      {error && value === "" && (
        <div className="input__error">{errorText}</div>
      )}
    </div>
  );
}